export default __webpack_public_path__ + "static/media/ourP4.89ec1a69.png";